import { TableHeader as TableHeaderBase } from "react-stately";

import type { HTMLAttributes, JSX } from "react";
import type { TableHeaderProps as TableHeaderBaseProps } from "react-stately";

export type TableHeaderProps<T> = TableHeaderBaseProps<T> &
  Omit<HTMLAttributes<HTMLTableSectionElement>, keyof TableHeaderBaseProps<T>>;

export const TableHeader = TableHeaderBase as <T>(props: TableHeaderProps<T>) => JSX.Element;
